import React from 'react'
import { Route } from 'react-router-dom'
import { withPortalIdByRoute } from './withPortalIdByRoute'

const PublicPortalRoute = props => (
  <Route {...props} component={withPortalIdByRoute(props.component)} />
)

export default PublicPortalRoute



// WEBPACK FOOTER //
// ./src/modules/portal/PublicPortalRoute.js